module.exports = __webpack_public_path__ + "media/img/1855-5e6e971b6c24d507489297624be0204c.png";